import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CreateUser from './pages/CreateUser';
import ListUser from './pages/ListUser';
import EditUser from './pages/EditUser';
import EditUserPin from './pages/EditUserPin';

const User = () => {
  return (
    <Routes>
      <Route path="" element={<ListUser />} />
      <Route path="create" element={<CreateUser />} />
      <Route path="edit/:id" element={<EditUser />} />
      <Route path="edit-pin/:id" element={<EditUserPin />} />
    </Routes>
  );
};

export default User;
